import React from 'react';

export type FollowUpStatus = 'completed' | 'not_required' | null | undefined;

export function getFollowUpStatusLabel(status: FollowUpStatus): string | null {
  if (status === 'completed') return 'Completed';
  if (status === 'not_required') return 'Not Required';
  return null;
}

const FollowUpStatusBadge: React.FC<{ status: FollowUpStatus; className?: string }> = ({ status, className }) => {
  const label = getFollowUpStatusLabel(status);
  if (!label) return null;

  const tone =
    status === 'completed'
      ? 'bg-emerald-500/15 text-emerald-300 border-emerald-500/40'
      : 'bg-slate-500/20 text-slate-200 border-slate-500/50';

  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${tone} ${className || ''}`}>
      {label}
    </span>
  );
};

export default FollowUpStatusBadge;
